 
 
 
 
 
 
define(['./locale'], function(Locale) {
    'use strict';
    return function(languageCode, serviceType) {
        var locale = new Locale(languageCode);
        return locale.getValueFor(serviceType) === languageCode;
    };
});



// WEBPACK FOOTER //
// ./config/language/validator.js